var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/White/Add") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "G01",
    transform: "translate(-118.000000, -25.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/White/Add",
    transform: "translate(118.541969, 25.541569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8067871,11.3483566 L13.5685046,11.3483566 L13.5685046,1.110074 C13.5685046,0.498033202 13.0704714,0 12.4584306,0 C11.8463898,0 11.3483566,0.498033202 11.3483566,1.110074 L11.3483566,11.3483566 L1.110074,11.3483566 C0.498033202,11.3483566 0,11.8463898 0,12.4584306 C0,13.0704714 0.498033202,13.5685046 1.110074,13.5685046 L11.3483566,13.5685046 L11.3483566,23.8067871 C11.3483566,24.4188279 11.8463898,24.9168611 12.4584306,24.9168611 C13.0704714,24.9168611 13.5685046,24.4188279 13.5685046,23.8067871 L13.5685046,13.5685046 L23.8067871,13.5685046 C24.4188279,13.5685046 24.9168611,13.0704714 24.9168611,12.4584306 C24.9168611,11.8463898 24.4188279,11.3483566 23.8067871,11.3483566 Z",
    id: "Fill-7"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhite);
export default __webpack_public_path__ + "static/media/White.a7314412245c44b7a39c385203afb7af.svg";
export { ForwardRef as ReactComponent };